import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ProgressSpinnerService } from '@shared/services/progress-spinner.service';
import { BlockUIModule } from 'primeng/blockui';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-progress-spinner',
  imports: [ProgressSpinnerModule, BlockUIModule, CommonModule],
  templateUrl: './progress-spinner.component.html',
  styleUrl: './progress-spinner.component.scss'
})
export class ProgressSpinnerComponent {
  constructor(public progressSpinnerService: ProgressSpinnerService) {}
}
